import createIcon from "../create-icon";

export const ChevronDownIcon = createIcon("ChevronDown", [
  ["polyline", { points: "6 9 12 15 18 9", key: "1do0m2" }],
]);
